let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4QvDr")).then(() => parcelRequire('gAMe3'));